module.exports = __webpack_public_path__ + "static/media/ProblemSolving.ee655a26.png";